import { initialAttachmentState } from '@atlassian/jira-issue-attachments-store/src/common/utils.tsx';
import type { State } from '@atlassian/jira-issue-attachments-store/src/types.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

export const getIssueAttachment = (state: State, issueKey: IssueKey) =>
	state.issueAttachments[issueKey] || initialAttachmentState;

export const getTotalCount = (state: State, issueKey: string) =>
	getIssueAttachment(state, issueKey).totalCount;
